export default {
    data: `[
   {
      "id":"754e81a6-d3e9-4c78-829f-354d34089914",
      "logicalname":"creaza_italia_roma_010",
      "theme":"italy",
      "translations":{
         "nb_NO":"Tiberelven 2 (Roma)",
         "nn_NO":"Tiberelva 2 (Roma)",
         "sv_SE":"Tiber 2 (Rom)",
         "en_US":"Tiber 2 (Rome)"
      }
   },
   {
      "id":"9b1166e4-aa2b-4f86-a016-5bfd26801522",
      "logicalname":"creaza_italia_candelora_001",
      "theme":"italy",
      "translations":{
         "nb_NO":"Kyndelsmesse 1 (Venezia)",
         "nn_NO":"Kyndelsmesse 1 (Venezia)",
         "sv_SE":"Día de la Candelaria 1 (Venedig)",
         "en_US":"Candlemas 1 (Venice)"
      }
   },
   {
      "id":"71f50cf8-8986-4c6f-bd5c-9174ecd9d979",
      "logicalname":"creaza_italia_candelora_002",
      "theme":"italy",
      "translations":{
         "nb_NO":"Kyndelsmesse 2 (Venezia)",
         "nn_NO":"Kyndelsmesse 2 (Venezia)",
         "sv_SE":"Día de la Candelaria 2 (Venedig)",
         "en_US":"Candlemas 2 (Venice)"
      }
   },
   {
      "id":"a7a0025d-2ea2-4f4d-bc0c-4c22e3d702dc",
      "logicalname":"creaza_italia_candelora_003",
      "theme":"italy",
      "translations":{
         "nb_NO":"Kyndelsmesse 3 (Venezia)",
         "nn_NO":"Kyndelsmesse 3 (Venezia)",
         "sv_SE":"Día de la Candelaria 3 (Venedig)",
         "en_US":"Candlemas 3 (Venice)"
      }
   },
   {
      "id":"15e023f0-b9f2-4cc4-806d-a2188d01b3ee",
      "logicalname":"creaza_italia_candelora_004",
      "theme":"italy",
      "translations":{
         "nb_NO":"Kyndelsmesse 4 (Venezia)",
         "nn_NO":"Kyndelsmesse 4 (Venezia)",
         "sv_SE":"Día de la Candelaria 4 (Venedig)",
         "en_US":"Candlemas 4 (Venice)"
      }
   },
   {
      "id":"e54a263c-02ab-41e0-ae53-8298a7f2860a",
      "logicalname":"creaza_italia_candelora_005",
      "theme":"italy",
      "translations":{
         "nb_NO":"Kyndelsmesse 5 (Venezia)",
         "nn_NO":"Kyndelsmesse 5 (Venezia)",
         "sv_SE":"Día de la Candelaria 5 (Venedig)",
         "en_US":"Candlemas 5 (Venice)"
      }
   },
   {
      "id":"7267eac2-d601-4f33-8e55-ac0ffa086ffb",
      "logicalname":"creaza_italia_candelora_006",
      "theme":"italy",
      "translations":{
         "nb_NO":"Kyndelsmesse 6 (Venezia)",
         "nn_NO":"Kyndelsmesse 6 (Venezia)",
         "sv_SE":"Día de la Candelaria 6 (Venedig)",
         "en_US":"Candlemas 6 (Venice)"
      }
   },
   {
      "id":"1286e042-687e-4deb-aa00-5e28f46a8168",
      "logicalname":"creaza_italia_candelora_007",
      "theme":"italy",
      "translations":{
         "nb_NO":"Kyndelsmesse 7 (Venezia)",
         "nn_NO":"Kyndelsmesse 7 (Venezia)",
         "sv_SE":"Día de la Candelaria 7 (Venedig)",
         "en_US":"Candlemas 7 (Venice)"
      }
   },
   {
      "id":"7d99377a-127f-45d8-9e1e-eb056242ed39",
      "logicalname":"creaza_italia_carneval_001",
      "theme":"italy",
      "translations":{
         "nb_NO":"Karneval (Italia)",
         "nn_NO":"Karneval (Italia)",
         "sv_SE":"Karneval (Italien)",
         "en_US":"Carnival (Italy)"
      }
   },
   {
      "id":"0de56629-7316-4de5-9b01-a7632eb0a6cb",
      "logicalname":"creaza_italia_carneval_002",
      "theme":"italy",
      "translations":{
         "nb_NO":"Karnevalsparade 1 (Italia)",
         "nn_NO":"Karnevalsparade 1 (Italia)",
         "sv_SE":"Karnevalparad 1 (Italien)",
         "en_US":"Carnival parade 1 (Italy)"
      }
   },
   {
      "id":"541c9b7a-09bd-4be8-9526-02943e796b85",
      "logicalname":"creaza_italia_carneval_003",
      "theme":"italy",
      "translations":{
         "nb_NO":"Karnevalsparade 2 (Italia)",
         "nn_NO":"Karnevalsparade 2 (Italia)",
         "sv_SE":"Karnevalparad 2 (Italien)",
         "en_US":"Carnival parade 2 (Italy)"
      }
   },
   {
      "id":"68fbbce9-2ab6-4f54-b884-9adccbaea0f2",
      "logicalname":"creaza_italia_carneval_004",
      "theme":"italy",
      "translations":{
         "nb_NO":"Karnevalsparade 3 (Italia)",
         "nn_NO":"Karnevalsparade 3 (Italia)",
         "sv_SE":"Karneval-parad 3 (Italien)",
         "en_US":"Carnival parade 3 (Italy)"
      }
   },
   {
      "id":"e12476b5-61a5-4e1e-85f6-24342605b4e9",
      "logicalname":"creaza_italia_carneval_005",
      "theme":"italy",
      "translations":{
         "nb_NO":"Karnevalsparade 4 (Italia)",
         "nn_NO":"Karnevalsparade 4 (Italia)",
         "sv_SE":"Karneval-parad 4 (Italien)",
         "en_US":"Carnival parade 4 (Italy)"
      }
   },
   {
      "id":"2ffe8f14-3090-4d15-b693-2c95042beb08",
      "logicalname":"creaza_italia_catania_001",
      "theme":"italy",
      "translations":{
         "nb_NO":"Duomo-plassen (Catania)",
         "nn_NO":"Duomo-plassen (Catania)",
         "sv_SE":"Piazza Duomo (Katania)",
         "en_US":"Piazza Duomo (Catania)"
      }
   },
   {
      "id":"516be8c6-b124-477e-bcc1-30b2327e092d",
      "logicalname":"creaza_italia_catania_002",
      "theme":"italy",
      "translations":{
         "nb_NO":"Biscari-palasset (Catania)",
         "nn_NO":"Biscari-palasset (Catania)",
         "sv_SE":"Palazzo Biscari (Kantania)",
         "en_US":"Palazzo Biscari (Catania)"
      }
   },
   {
      "id":"a12c4077-68f3-4445-8de0-9b9421629b9b",
      "logicalname":"creaza_italia_catania_003",
      "theme":"italy",
      "translations":{
         "nb_NO":"Marionetter (Catania)",
         "nn_NO":"Marionettar (Catania)",
         "sv_SE":"Dockor (Katania)",
         "en_US":"Puppets (Catania)"
      }
   },
   {
      "id":"6111db96-4633-48c3-b74c-cac6ad16ce94",
      "logicalname":"creaza_italia_catania_004",
      "theme":"italy",
      "translations":{
         "nb_NO":"Appelsinselger (Catania)",
         "nn_NO":"Appelsinseljar (Catania)",
         "sv_SE":"Apelsinförsäljare (Katania)",
         "en_US":"Orange salesman (Catania)"
      }
   },
   {
      "id":"ce3920eb-664b-4cac-b4b7-8f3725cb3a50",
      "logicalname":"creaza_italia_catania_005",
      "theme":"italy",
      "translations":{
         "nb_NO":"Sankt Nikolas-kirken (Catania)",
         "nn_NO":"Sankt Nikolas-kyrkja (Catania)",
         "sv_SE":"San Nicolo kyrkan (Katania)",
         "en_US":"The Church of San Nicolo (Catania)"
      }
   },
   {
      "id":"0d9c2c7c-ebbc-41ee-8dc0-3dc3c34f3b7a",
      "logicalname":"creaza_italia_catania_008",
      "theme":"italy",
      "translations":{
         "nb_NO":"Sankt Agatha-katedralen (Catania)",
         "nn_NO":"Sankt Agatha-katedralen (Catania)",
         "sv_SE":"St. Agathas katedral (Catania)",
         "en_US":"Cathedral of St. Agatha (Catania)"
      }
   },
   {
      "id":"9489eacc-561b-4be3-b863-7d212bca090b",
      "logicalname":"creaza_italia_catania_009",
      "theme":"italy",
      "translations":{
         "nb_NO":"Fiskemarked 1 (Catania)",
         "nn_NO":"Fiskemarknad 1 (Catania)",
         "sv_SE":"Fiskmarknad1 (Katania)",
         "en_US":"Fish market 1 (Catania)"
      }
   },
   {
      "id":"d29f1999-59fe-422b-9970-e5ecc606d850",
      "logicalname":"creaza_italia_catania_010",
      "theme":"italy",
      "translations":{
         "nb_NO":"Fiskemarked 2 (Catania)",
         "nn_NO":"Fiskemarknad 2 (Catania)",
         "sv_SE":"Fiskmarknad 2 (Katania)",
         "en_US":"Fish market 2 (Catania)"
      }
   },
   {
      "id":"dcc27e26-51cb-4dec-a277-7de698b560f0",
      "logicalname":"creaza_italia_firenze_001",
      "theme":"italy",
      "translations":{
         "nb_NO":"Katedral (Firenze)",
         "nn_NO":"Katedral (Firenze)",
         "sv_SE":"Florens katedral (Florens)",
         "en_US":"Florence Cathedral (Florence)"
      }
   },
   {
      "id":"f3299814-0ba0-4782-a912-23048d5bf230",
      "logicalname":"creaza_italia_firenze_002",
      "theme":"italy",
      "translations":{
         "nb_NO":"Basilica di Santa Maria del Fiore (Firenze)",
         "nn_NO":"Basilica di Santa Maria del Fiore (Firenze)",
         "sv_SE":"Ponte Vecchio (Florens)",
         "en_US":"Ponte Vecchio (Florence)"
      }
   },
   {
      "id":"21c15b50-a573-49f6-bec9-e5b4c9e4bc0a",
      "logicalname":"creaza_italia_firenze_003",
      "theme":"italy",
      "translations":{
         "nb_NO":"Pinokkiodukker (Firenze)",
         "nn_NO":"Pinokkiodukker (Firenze)",
         "sv_SE":"Pinocchio (Florens)",
         "en_US":"Pinocchio (Florence)"
      }
   },
   {
      "id":"22da785f-9701-487f-95b9-3e7720c95485",
      "logicalname":"creaza_italia_firenze_004",
      "theme":"italy",
      "translations":{
         "nb_NO":"Brunelleschi, utsikt 1 (Firenze)",
         "nn_NO":"Brunelleschi, utsikt 1 (Firenze)",
         "sv_SE":"Brunelleschi utsikt 1 (Florens)",
         "en_US":"Brunelleschi view 1 (Florence)"
      }
   },
   {
      "id":"bed456c5-3d54-482c-96ae-337a077dd50c",
      "logicalname":"creaza_italia_firenze_005",
      "theme":"italy",
      "translations":{
         "nb_NO":"Ponte Vecchio, utsikt mot bro (firenze)",
         "nn_NO":"Ponte Vecchio, utsikt mot bru (firenze)",
         "sv_SE":"Ponte Vecchio, vy mot bron (Florens)",
         "en_US":"Ponte Vecchio, view towards bridge (Florence)"
      }
   },
   {
      "id":"b251be11-1d8e-4f05-b483-513dc5f7d41a",
      "logicalname":"creaza_italia_firenze_006",
      "theme":"italy",
      "translations":{
         "nb_NO":"Duer på gaten (Firenze)",
         "nn_NO":"Duer på gata (Firenze)",
         "sv_SE":"Duvor på gatan (Florens)",
         "en_US":"Pigeons on the street (Florence)"
      }
   },
   {
      "id":"386fbc2b-efa5-46f2-95df-dee58a238440",
      "logicalname":"creaza_italia_firenze_007",
      "theme":"italy",
      "translations":{
         "nb_NO":"Signoria tårn (Firenze)",
         "nn_NO":"Signoria tårn (Firenze)",
         "sv_SE":"Signoria Tower (Florence)",
         "en_US":"Signoria Tower (Florence)"
      }
   },
   {
      "id":"4120f595-ce2e-4c02-af07-a6c4a51b8a98",
      "logicalname":"creaza_italia_firenze_008",
      "theme":"italy",
      "translations":{
         "nb_NO":"Brunelleschi, utsikt 2 (Firenze)",
         "nn_NO":"Brunelleschi, utsikt 2 (Firenze)",
         "sv_SE":"Brunelleschi utsikt 2 (Florens)",
         "en_US":"Brunelleschi view 2 (Florence)"
      }
   },
   {
      "id":"8dc17583-8fac-4a5d-bfac-dd88e17092a2",
      "logicalname":"creaza_italia_firenze_009",
      "theme":"italy",
      "translations":{
         "nb_NO":"David-skulptur (Firenze)",
         "nn_NO":"David-skulptur (Firenze)",
         "sv_SE":"David (Florens)",
         "en_US":"David (Florence)"
      }
   },
   {
      "id":"f8e9ef12-ab2c-45b4-9f8e-60166479a0b0",
      "logicalname":"creaza_italia_firenze_010",
      "theme":"italy",
      "translations":{
         "nb_NO":"Brunelleschi, interiør (Firenze)",
         "nn_NO":"Brunelleschi, inne (Firenze)",
         "sv_SE":"Brunelleschi insida (Florens)",
         "en_US":"Brunelleschi interior (Florence)"
      }
   },
   {
      "id":"a5e95ddb-739f-4128-8034-b07feeaaf4dd",
      "logicalname":"creaza_italia_palermo_001",
      "theme":"italy",
      "translations":{
         "nb_NO":"Katedral, reflektert (Palermo)",
         "nn_NO":"Katedral, refleksjon (Palermo)",
         "sv_SE":"Reflektioner av katedral (Palermo)",
         "en_US":"Cathedral reflection (Palermo)"
      }
   },
   {
      "id":"8d456a17-a4b4-46c4-9352-a2538f72a7c4",
      "logicalname":"creaza_italia_palermo_002",
      "theme":"italy",
      "translations":{
         "nb_NO":"Vucciria-markedet (Palermo)",
         "nn_NO":"Vucciria-marknaden (Palermo)",
         "sv_SE":"Vucciria marknad (Palermo)",
         "en_US":"Vucciria Market (Palermo)"
      }
   },
   {
      "id":"085b87df-af20-4109-9145-d8939d3d7b1c",
      "logicalname":"creaza_italia_palermo_003",
      "theme":"italy",
      "translations":{
         "nb_NO":"Gatealter (Palermo)",
         "nn_NO":"Gatealter (Palermo)",
         "sv_SE":"Väggljus (Palermo)",
         "en_US":"Wall shrine (Palermo)"
      }
   },
   {
      "id":"0b4bc844-a178-44a0-be65-1c4ca2650687",
      "logicalname":"creaza_italia_palermo_004",
      "theme":"italy",
      "translations":{
         "nb_NO":"Santa Rosalia-fest 1 (Palermo)",
         "nn_NO":"Santa Rosalia-fest 1 (Palermo)",
         "sv_SE":"Rosfestivalen 1 (Palermo)",
         "en_US":"Festa S. Rosalia 1 (Palermo)"
      }
   },
   {
      "id":"1759ec4c-515c-4e96-ba85-7ffe3f103bb3",
      "logicalname":"creaza_italia_palermo_005",
      "theme":"italy",
      "translations":{
         "nb_NO":"Santa Rosalia-fest 2 (Palermo)",
         "nn_NO":"Santa Rosalia-fest 2 (Palermo)",
         "sv_SE":"Rosfestivalen 2 (Palermo)",
         "en_US":"Festa S. Rosalia 2 (Palermo)"
      }
   },
   {
      "id":"f2f7cdb1-faa9-416c-8361-4d51c20a03be",
      "logicalname":"creaza_italia_palermo_006",
      "theme":"italy",
      "translations":{
         "nb_NO":"Hestevogn (Palermo)",
         "nn_NO":"Hestevogn (Palermo)",
         "sv_SE":"Häst och vagn (Palermo)",
         "en_US":"Horse cart (Palermo)"
      }
   },
   {
      "id":"0420d62e-0c9f-4624-bb2e-9b3a36b85c56",
      "logicalname":"creaza_italia_roma_001",
      "theme":"italy",
      "translations":{
         "nb_NO":"Tiberelven 1 (Roma)",
         "nn_NO":"Tiberelva 1 (Roma)",
         "sv_SE":"Tiber 1 (Rom)",
         "en_US":"Tiber 1 (Rome)"
      }
   },
   {
      "id":"58b57b3f-0467-4ef6-9ab6-f6d59b923e08",
      "logicalname":"creaza_italia_roma_002",
      "theme":"italy",
      "translations":{
         "nb_NO":"Jupiter-statue (Roma)",
         "nn_NO":"Jupiter-statue (Roma)",
         "sv_SE":"Jupiter statyn (Rom)",
         "en_US":"Jupiter statue (Rome)"
      }
   },
   {
      "id":"06c13146-ce54-40f9-859b-d4c40df34804",
      "logicalname":"creaza_italia_roma_003",
      "theme":"italy",
      "translations":{
         "nb_NO":"Campidoglio-plassen 1 (Roma)",
         "nn_NO":"Campidoglio-plassen 1 (Roma)",
         "sv_SE":"Piazza del Campidoglio 1 (Rom)",
         "en_US":"Piazza del Campidoglio 1 (Rome)"
      }
   },
   {
      "id":"61f11987-d774-4b68-a4be-5799a3fe2b95",
      "logicalname":"creaza_italia_roma_004",
      "theme":"italy",
      "translations":{
         "nb_NO":"Triumfbue (Roma)",
         "nn_NO":"Triumfboge (Roma)",
         "sv_SE":"Triumfbågen (Rom)",
         "en_US":"Triumphal Arch (Rome)"
      }
   },
   {
      "id":"b520f556-4b35-432b-8b83-1b723eccddf9",
      "logicalname":"creaza_italia_roma_005",
      "theme":"italy",
      "translations":{
         "nb_NO":"Petersplassen (Roma)",
         "nn_NO":"Petersplassen (Roma)",
         "sv_SE":"Petersplatsen (Rom)",
         "en_US":"St. Peter's Square (Rome)"
      }
   },
   {
      "id":"82a855f9-cf21-4b84-800d-8bff329ed8ed",
      "logicalname":"creaza_italia_roma_006",
      "theme":"italy",
      "translations":{
         "nb_NO":"Trajansøylen (Roma)",
         "nn_NO":"Trajansøyla (Roma)",
         "sv_SE":"Trajanuskolonnen (Rom)",
         "en_US":"Trajan's Column (Rome)"
      }
   },
   {
      "id":"6055f637-7df2-4a5b-8816-26697efe4450",
      "logicalname":"creaza_italia_roma_007",
      "theme":"italy",
      "translations":{
         "nb_NO":"Forum Romanum (Roma)",
         "nn_NO":"Forum Romanum (Roma)",
         "sv_SE":"Forum Romanum (Rom)",
         "en_US":"Forum Romanum (Rome)"
      }
   },
   {
      "id":"c5ce8207-7dee-4896-bada-c4751ec2a3a7",
      "logicalname":"creaza_italia_roma_008",
      "theme":"italy",
      "translations":{
         "nb_NO":"Circus Maximus (Roma)",
         "nn_NO":"Circus Maximus (Roma)",
         "sv_SE":"Circus Maximus (Rom)",
         "en_US":"Circus Maximus (Rome)"
      }
   },
   {
      "id":"cba049fb-6dcb-4733-beb4-89e02de95d62",
      "logicalname":"creaza_italia_roma_009",
      "theme":"italy",
      "translations":{
         "nb_NO":"Campidoglio-plassen 2 (Roma)",
         "nn_NO":"Campidoglio-plassen 2 (Roma)",
         "sv_SE":"Piazza del Campidoglio 2 (Rom)",
         "en_US":"Piazza del Campidoglio 2 (Rome)"
      }
   },
   {
      "id":"7eb9a6d2-4346-4f09-b391-8f0935d3c011",
      "logicalname":"creaza_italia_roma_011",
      "theme":"italy",
      "translations":{
         "nb_NO":"Peterskirken (Roma)",
         "nn_NO":"Peterskyrkja (Roma)",
         "sv_SE":"Peterskyrkan (Rom)",
         "en_US":"St. Peter's Basilica (Rome)"
      }
   },
   {
      "id":"73afafac-18d0-4c05-bb28-629e3933b115",
      "logicalname":"creaza_italia_roma_012",
      "theme":"italy",
      "translations":{
         "nb_NO":"Tiberelven 3 (Roma)",
         "nn_NO":"Tiberelva 3 (Roma)",
         "sv_SE":"Tiber 3 (Rom)",
         "en_US":"Tiber 3 (Rome)"
      }
   },
   {
      "id":"2fd29433-ffe0-4fc2-989a-68e605488e50",
      "logicalname":"creaza_italia_roma_013",
      "theme":"italy",
      "translations":{
         "nb_NO":"Snurrende plakat (Roma)",
         "nn_NO":"Snurrande plakat (Roma)",
         "sv_SE":"Snurrande tavla (Rom)",
         "en_US":"Revolving Poster (Rome)"
      }
   },
   {
      "id":"534f9212-d26b-41db-b8a2-4b78c2d4d2e9",
      "logicalname":"creaza_italia_roma_014",
      "theme":"italy",
      "translations":{
         "nb_NO":"Tiberelven 4 (Roma)",
         "nn_NO":"Tiberelva 4 (Roma)",
         "sv_SE":"Tiber 4 (Rom)",
         "en_US":"Tiber 4 (Rome)"
      }
   },
   {
      "id":"de058146-3b3a-433d-b6ce-8ef16270477a",
      "logicalname":"creaza_italia_roma_016",
      "theme":"italy",
      "translations":{
         "nb_NO":"Santa Maria Maggiore (Roma)",
         "nn_NO":"Santa Maria Maggiore (Roma)",
         "sv_SE":"Santa Maria Maggiore kyrka (Rom)",
         "en_US":"Basilica Santa Maria Maggiore (Rome)"
      }
   },
   {
      "id":"39b03c8e-f8bd-4368-9dc3-a6fa7b5b872a",
      "logicalname":"creaza_italia_roma_017",
      "theme":"italy",
      "translations":{
         "nb_NO":"Trajans marked (Roma)",
         "nn_NO":"Trajan-marknadane (Roma)",
         "sv_SE":"Trajanus Saluhallar (Rom)",
         "en_US":"Trajan's Markets (Rome)"
      }
   },
   {
      "id":"62d7363e-9b33-423d-9a58-4f67616b1154",
      "logicalname":"creaza_italia_roma_018",
      "theme":"italy",
      "translations":{
         "nb_NO":"Alter (Roma)",
         "nn_NO":"Alter (Roma)",
         "sv_SE":"Viktor Emanuel-monumentet (Rom)",
         "en_US":"Altar (Rome)"
      }
   },
   {
      "id":"b97e61ef-e85b-46c9-907d-710bd4601628",
      "logicalname":"creaza_italia_roma_019",
      "theme":"italy",
      "translations":{
         "nb_NO":"Pantheon, inne (Roma)",
         "nn_NO":"Pantheon interlør (Roma)",
         "sv_SE":"Pantheon insida (Rom)",
         "en_US":"Pantheon, interior (Rome)"
      }
   },
   {
      "id":"a9f3feee-8a6d-42af-9fae-3965b121cc8c",
      "logicalname":"creaza_italia_roma_020",
      "theme":"italy",
      "translations":{
         "nb_NO":"Pantheon, ute (Roma)",
         "nn_NO":"Pantheon, ute (Roma)",
         "sv_SE":"Pantheon, Utsida (Rom)",
         "en_US":"Pantheon, exterior (Rome)"
      }
   },
   {
      "id":"3af7f12a-1a02-4eed-b6c8-011a3e7ae5b9",
      "logicalname":"creaza_italia_roma_021",
      "theme":"italy",
      "translations":{
         "nb_NO":"Peterskirken interiør 1 (Roma)",
         "nn_NO":"Peterskyrkja, inne 1 (Roma)",
         "sv_SE":"Peterkyrkan, insida 1 (Rom)",
         "en_US":"St. Peter's Basilica, interior 1 (Rome)"
      }
   },
   {
      "id":"995f7a64-809f-4f2d-965b-e54398a78177",
      "logicalname":"creaza_italia_roma_022",
      "theme":"italy",
      "translations":{
         "nb_NO":"Peterskirken, ute 1 (Roma)",
         "nn_NO":"Peterskyrkja, ute 1 (Roma)",
         "sv_SE":"Peterskyrkan, utsida 1 (Rom)",
         "en_US":"St. Peter's Basilica, exterior 1 (Rome)"
      }
   },
   {
      "id":"57b4be03-0100-4565-b356-ed40961ee117",
      "logicalname":"creaza_italia_roma_023",
      "theme":"italy",
      "translations":{
         "nb_NO":"Peterskirken interiør 2 (Roma)",
         "nn_NO":"Peterskyrkja, inne 2 (Roma)",
         "sv_SE":"Peterskyrkan, insida 2 (Rom)",
         "en_US":"St. Peter's Basilica, interior 2 (Rome)"
      }
   },
   {
      "id":"b2598c5f-fee6-44af-81f4-13a21b0b20eb",
      "logicalname":"creaza_italia_roma_024",
      "theme":"italy",
      "translations":{
         "nb_NO":"Peterskirken interiør 3 (Roma)",
         "nn_NO":"Peterskyrkja, inne 3 (Roma)",
         "sv_SE":"Peterskyrkan, insida 3 (Rom)",
         "en_US":"St. Peter's Basilica, interior 3 (Rome)"
      }
   },
   {
      "id":"67f3bc2e-e944-4e09-8ea1-fd77c87f9d1c",
      "logicalname":"creaza_italia_roma_025",
      "theme":"italy",
      "translations":{
         "nb_NO":"Pietà (Roma)",
         "nn_NO":"Pietà (Roma)",
         "sv_SE":"Pietà (Rom)",
         "en_US":"Pietà (Rome)"
      }
   },
   {
      "id":"7498bb67-8184-4553-a65a-6e157324e5bd",
      "logicalname":"creaza_italia_roma_026",
      "theme":"italy",
      "translations":{
         "nb_NO":"Peterskirken interiør 4 (Roma)",
         "nn_NO":"Peterskyrkja, inne 4 (Roma)",
         "sv_SE":"Peterskyrkan, insida 4 (Rom)",
         "en_US":"St. Peter's Basilica, interior 4 (Rome)"
      }
   },
   {
      "id":"436ce7f8-588e-4db6-a741-a0ef152128f7",
      "logicalname":"creaza_italia_roma_027",
      "theme":"italy",
      "translations":{
         "nb_NO":"Peterskirken interiør 5 (Roma)",
         "nn_NO":"Peterskyrkja, inne 5 (Roma)",
         "sv_SE":"Peterskyrkan, insida 5 (Rom)",
         "en_US":"St. Peter's Basilica, interior 5 (Rome)"
      }
   },
   {
      "id":"cbdc8b3e-e089-4785-9f65-1329615c667c",
      "logicalname":"creaza_italia_venice_001",
      "theme":"italy",
      "translations":{
         "nb_NO":"Gondol ved Sospiri bro (Venezia)",
         "nn_NO":"Gondol ved Sospiri bru (Venezia)",
         "sv_SE":"Gondoler vid Sighs bro (Venedig)",
         "en_US":"Gondolas at the Bridge of Sighs (Venice)"
      }
   },
   {
      "id":"1c3c060a-b8b1-49d9-bf9e-5ee9c4e9d0b4",
      "logicalname":"creaza_italia_venice_002",
      "theme":"italy",
      "translations":{
         "nb_NO":"Gondoler foran San Giorgio 1 (Venezia)",
         "nn_NO":"Gondolar framføre San Giorgio 1 (Venezia)",
         "sv_SE":"Gondoler framför St. George’s basilika 1 (Venice)",
         "en_US":"Gondolas in front of St. George’s church 1 (Venice)"
      }
   },
   {
      "id":"0bd89321-a892-4f74-b57b-0795d0477984",
      "logicalname":"creaza_italia_venice_003",
      "theme":"italy",
      "translations":{
         "nb_NO":"Gondoler foran San Giorgio 2 (Venezia)",
         "nn_NO":"Gondolar framføre San Giorgio 2 (Venezia)",
         "sv_SE":"Gondoler framför St. George’s basilika 2 (Venice)",
         "en_US":"Gondolas in front of St. George’s church 2 (Venice)"
      }
   },
   {
      "id":"efebbc36-5ff1-4c17-b83c-0bfd1908f387",
      "logicalname":"creaza_italia_venice_004",
      "theme":"italy",
      "translations":{
         "nb_NO":"Fra San Marco-tårnet (Roma)",
         "nn_NO":"Frå San Marco-tårnet (Roma)",
         "sv_SE":"Från San Marco Campanile (Venice)",
         "en_US":"From St. Mark’s Tower (Venice)"
      }
   },
   {
      "id":"a255512a-ff1c-494c-b8db-99c1cfe3b07a",
      "logicalname":"creaza_italia_venice_005",
      "theme":"italy",
      "translations":{
         "nb_NO":"Canal Grande (Venezia)",
         "nn_NO":"Canal Grande (Venezia)",
         "sv_SE":"Stora kanalen (Venice)",
         "en_US":"Grand Canal (Venice)"
      }
   },
   {
      "id":"fc2e7edc-2d6c-4d38-86c1-f7d5bf53cb23",
      "logicalname":"creaza_italia_venice_006",
      "theme":"italy",
      "translations":{
         "nb_NO":"Kanal (Venezia)",
         "nn_NO":"Kanal (Venezia)",
         "sv_SE":"Kanaler (Venice)",
         "en_US":"Canals (Venice)"
      }
   },
   {
      "id":"e58fdace-4757-4c40-b7e5-edb24dda5509",
      "logicalname":"creaza_italia_venice_007",
      "theme":"italy",
      "translations":{
         "nb_NO":"Utsikt fra Dogana-broen (Venezia)",
         "nn_NO":"Utsikt frå Dogana-brua (Venezia)",
         "sv_SE":"Vy från Dogana De Mare (Venice)",
         "en_US":"View from Dogana Bridge (Venice)"
      }
   },
   {
      "id":"4afd5bba-a5fa-4050-8a86-e7565d7ec4d2",
      "logicalname":"creaza_italia_venice_008",
      "theme":"italy",
      "translations":{
         "nb_NO":"Gondoler (Venezia)",
         "nn_NO":"Gondolar (Venezia)",
         "sv_SE":"Gondoler (Venice)",
         "en_US":"Gondolas (Venice)"
      }
   },
   {
      "id":"3e96b7f4-304a-4e6f-be78-c788bae744c1",
      "logicalname":"creaza_italia_venice_009",
      "theme":"italy",
      "translations":{
         "nb_NO":"Gondoler (Venezia)",
         "nn_NO":"Gondolar (Venezia)",
         "sv_SE":"Gondoler 2 (Venice)",
         "en_US":"Gondolas (Venice)"
      }
   },
   {
      "id":"2d0db9e3-778f-40e2-a639-52421d89d4f4",
      "logicalname":"creaza_italia_venice_010",
      "theme":"italy",
      "translations":{
         "nb_NO":"San Marco-plassen (Venezia)",
         "nn_NO":"San Marco-plassen (Venezia)",
         "sv_SE":"Markusplatsen (Venice)",
         "en_US":"St. Mark's Square (Venice)"
      }
   },
   {
      "id":"f015bf68-cab3-4611-994f-7ae455ab943d",
      "logicalname":"creaza_italia_venice_011",
      "theme":"italy",
      "translations":{
         "nb_NO":"Inni San Giorgio-kirken (Venezia)",
         "nn_NO":"San Giorgio-kyrkja, inne (Venezia)",
         "sv_SE":"Insidan av St. George's Basilika (Venice)",
         "en_US":"Interior of St. George's Church (Venice)"
      }
   },
   {
      "id":"c0958036-a314-4e8f-872e-9d22b3ce7cba",
      "logicalname":"creaza_italia_venice_012",
      "theme":"italy",
      "translations":{
         "nb_NO":"Lite fiskemarked (Venezia)",
         "nn_NO":"Liten fiskemarknad (Venezia)",
         "sv_SE":"Liten fiskmarknad (Venice)",
         "en_US":"Small fish market (Venice)"
      }
   },
   {
      "id":"bd99b535-c8bb-4bee-8e42-c2a8721dd31e",
      "logicalname":"creaza_italia_venice_013",
      "theme":"italy",
      "translations":{
         "nb_NO":"Gondol (Venezia)",
         "nn_NO":"Gondol (Venezia)",
         "sv_SE":"En gondol (Venice)",
         "en_US":"Gondola (Venice)"
      }
   },
   {
      "id":"0e9f8955-58cf-49be-8ba8-70327b4a5ad2",
      "logicalname":"creaza_italia_venice_014",
      "theme":"italy",
      "translations":{
         "nb_NO":"Mot Realto-broen (Venezia)",
         "nn_NO":"Mot Realto-brua (Venezia)",
         "sv_SE":"Mot Rialtobron (Venice)",
         "en_US":"Towards the Rialto Bridge (Venice)"
      }
   },
   {
      "id":"d6d964fd-fe2f-4d62-9867-b715fad8e0bc",
      "logicalname":"creaza_italia_venice_015",
      "theme":"italy",
      "translations":{
         "nb_NO":"Rialto-broen om natten (Venezia)",
         "nn_NO":"Rialto-brua om natta (Venezia)",
         "sv_SE":"Rialtobron på natten (Venice)",
         "en_US":"Rialto Bridge at night (Venice)"
      }
   }
]`
};



/** WEBPACK FOOTER **
 ** ./docs/video_italy.js
 **/